import moment from "moment";

export const monthOptions = [
  { label: "Januari", value: 1 },
  { label: "Februari", value: 2 },
  { label: "Maret", value: 3 },
  { label: "April", value: 4 },
  { label: "Mei", value: 5 },
  { label: "Juni", value: 6 },
  { label: "Juli", value: 7 },
  { label: "Agustus", value: 8 },
  { label: "September", value: 9 },
  { label: "Oktober", value: 10 },
  { label: "November", value: 11 },
  { label: "Desember", value: 12 },
];

const currentYear = new Date().getFullYear();
export const yearOptions = Array.from(
  { length: currentYear - 1990 + 1 },
  (_, i) => {
    const year = currentYear - i;
    return {
      label: String(year),
      value: year,
    };
  },
);

export const getConfigByPaket = (paketList = []) => {
  const safePaketList = Array.isArray(paketList) ? paketList : [];

  const baseColumn = {
    name: "namaCabang",
    label: "Cabang",
    options: {
      sort: false,
    },
  };

  const paketColumns = safePaketList.map((paket) => ({
    name: paket,
    label: paket,
    options: {
      sort: false,
    },
  }));

  return [baseColumn, ...paketColumns];
};

export const buildExcelRequestBodyPenjualanByPaket = ({
  month,
  year,
  dataTable = [],
  rawData = [],
}) => {
  const yearValue = year?.value || year;
  const monthValue = month?.label || month;

  const filename = `${yearValue}_${monthValue}_Laporan_Penjualan_By_Paket`;
  const paketNames = [
    ...new Set(
      rawData.flatMap((item) =>
        (item.dataPaket || []).map((paket) => paket.namaPaket),
      ),
    ),
  ];

  const sheets = [];

  if (dataTable.length > 0 && paketNames.length > 0) {
    sheets.push({
      name: `Laporan Penjualan By Paket ${monthValue} ${yearValue}`,
      headers: [
        "No",
        "Cabang",
        ...paketNames, 
      ],
      data: dataTable.map((rowData, rowIndex) => {
        const row = {
          No: rowIndex + 1,
          Cabang: rowData.namaCabang,
        };

        paketNames.forEach((paketName) => {
          row[paketName] = rowData[paketName] ?? 0;
        });

        return row;
      }),
    });
  }

  return {
    filename,
    sheets,
  };
};
